var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "contact-page"
  }, [_c('contact-hero-section', {
    attrs: {
      "fields": _vm.contactPageSections.sections.contact_hero_section.fields
    }
  }), _c('contact-divider-section', {
    attrs: {
      "fields": _vm.contactPageSections.sections.contact_divider_section.fields
    }
  }), _c('contact-text-section', {
    attrs: {
      "fields": _vm.contactPageSections.sections.contact_text_section.fields
    }
  }), _c('contact-info-section', {
    attrs: {
      "fields": _vm.contactPageSections.sections.contact_info_section.fields
    },
    on: {
      "openPopup": function ($event) {
        return _vm.$emit('openPopup', 'ARRIVAL');
      }
    }
  }), _c('contact-divider2-section', {
    attrs: {
      "fields": _vm.contactPageSections.sections.contact_divider2_section.fields
    }
  }), false ? _c('contact-text2-section', {
    attrs: {
      "fields": _vm.contactPageSections.sections.contact_text_2_section.fields
    }
  }) : _vm._e(), _c('contact-contact-section', {
    attrs: {
      "fields": _vm.contactPageSections.sections.contact_contact_section.fields
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }